module.exports = __webpack_public_path__ + "static/media/logo-donts-6.3174a302.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-donts-6.png
// module id = 1309
// module chunks = 0